module.exports = __webpack_public_path__ + "img/hazardEquip99.3ac29b11.png";